import * as React from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import ko from 'date-fns/locale/ko';
import moment, { Moment } from 'moment';

import './date-range-selector.scss';

registerLocale('ko', ko);

interface Props {
  startDate: Date;
  setStartDate: React.Dispatch<React.SetStateAction<Date>>;
  endDate: Date;
  setEndDate: React.Dispatch<React.SetStateAction<Date>>;
}

const DateRangeSelector: React.FunctionComponent<Props> = ({ startDate, setStartDate, endDate, setEndDate }) => {
  const handleDateStartPicker = (date: Date | null) => {
    if (date) {
      setStartDate(date);
      if (moment(date).isAfter(endDate)) {
        setEndDate(date);
      }
    }
  };
  const handleDateEndPicker = (date: Date | null) => {
    if (date) {
      setEndDate(date);
    }
  };

  const StartCustomInput = React.forwardRef(({ value, onClick, onChange }: any, ref: any) => (
    <div>
      <div className="date-range-selector__end-custom-input__label">
        <strong>시작일</strong>
      </div>
      <input
        value={value}
        className="date-range-selector__end-custom-input"
        onClick={onClick}
        onChange={onChange}
        ref={ref}></input>
    </div>
  ));

  const EndCustomInput = React.forwardRef(({ value, onClick, onChange }: any, ref: any) => (
    <div>
      <div className="date-range-selector__end-custom-input__label">
        <strong>종료일</strong>
      </div>
      <input
        value={value}
        className="date-range-selector__end-custom-input"
        onClick={onClick}
        onChange={onChange}
        ref={ref}></input>
    </div>
  ));

  return (
    <div className="date-range-selector">
      <div className="date-range-selector__range">
        <DatePicker
          calendarClassName="date-range-start"
          selectsStart
          selected={startDate}
          startDate={startDate}
          endDate={endDate}
          onChange={handleDateStartPicker}
          customInput={<StartCustomInput />}
          dateFormat="yyyy.MM.dd"
          showYearDropdown
          dropdownMode="select"
          locale={'ko'}
        />
        <DatePicker
          calendarClassName="date-range-end"
          selectsEnd
          selected={endDate}
          startDate={startDate}
          endDate={endDate}
          minDate={startDate}
          onChange={handleDateEndPicker}
          customInput={<EndCustomInput />}
          dateFormat="yyyy.MM.dd"
          showYearDropdown
          dropdownMode="select"
          locale={'ko'}
        />
      </div>
    </div>
  );
};
export default DateRangeSelector;
